// La page de recherche est passée à React (js/react/ecrans/Recherche.jsx).
//
// Les publications ne sont pas réécrites : `ListePostsFournie` prête un
// conteneur à la machinerie de `posts.js`, à qui la recherche fournit elle-même
// ce qu'il faut afficher.
//
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import Recherche from "../react/ecrans/Recherche.jsx";

export const rendre = vueReact(Recherche);
